import { TicketDetailsPage } from './TicketDetails'
import { TicketsViewType } from './TicketsViewType'

export const TicketPaymentDetails = (): JSX.Element => {
  return <TicketDetailsPage viewType={TicketsViewType.Payments} />
}
